import React from 'react'
import Modal from "react-bootstrap/Modal";
import { Row, Col } from "react-bootstrap";
import Card from 'react-bootstrap/Card';
const ViewReferrerList = ({ viewModal, setViewModal, referrerList }) => {
    return (
        <>
            <Modal
                show={viewModal}
                onHide={() => setViewModal(false)}
                size={"lg"}
            >
                <Modal.Header closeButton >
                    <Modal.Title >
                        View Referal Amount
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Row >
                        {referrerList?.referalDetails?.map((item, index) => (
                            <Col md={6} key={index}>
                                <Card >
                                    <Card.Body>
                                        <div>
                                            <h6 className='font-w600'>Service : <span className='text-info font-w500'>{item?.serviceId === null ? "N/A" : item?.serviceId?.serviceName}</span></h6>
                                            <h6 className='mt-1 font-w600'>Referral Percentage : <span className='text-info font-w500'>{item?.referalPercentage}%</span></h6>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Modal.Body>
            </Modal>

        </>
    )
}

export default ViewReferrerList